import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const Lazy = lazy(
  () => import(/* webpackChunkName: 'AccountProfile' */ './index'),
);

export default function AccountProfile(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <Lazy {...props} />
    </Suspense>
  );
}
